module.exports = __webpack_public_path__ + "static/media/self-istanbul.727956ba.jpg";